// extracted by mini-css-extract-plugin
export default {"successWrapper":"ForgotPasswordSuccess_successWrapper__i2OlJ"};